// Module
var code = "<v5-frame src=\"$ctrl.src\" params=\"$ctrl.params\"></v5-frame> ";
// Exports
export default code;